export const categories = [
  {
    id: 1,
    name: "Accommodation",
    quantity: 54,
  },
  {
    id: 2,
    name: " Advertising and Branding",
    quantity: 26,
  },
  {
    id: 3,
    name: " Appliances",
    quantity: 6,
  },
  {
    id: 4,
    name: "Arts & Culture",
    quantity: 8,
  },
  {
    id: 5,
    name: " Audio & Video",
    quantity: 5,
  },
  {
    id: 6,
    name: " Auditing / Accounting",
    quantity: 2,
  },
  {
    id: 7,
    name: " Building and Decor",
    quantity: 160,
  },
  {
    id: 8,
    name: "Business and Finance",
    quantity: 55,
  },
  {
    id: 9,
    name: "Cleaning Products",
    quantity: 1,
  },
  {
    id: 10,
    name: "Cleaning Services",
    quantity: 1,
  },
  {
    id: 11,
    name: "Doctors and Hospitals",
    quantity: 13,
  },
  {
    id: 12,
    name: "Computers & Internet",
    quantity: 15,
  },
  {
    id: 13,
    name: "Education",
    quantity: 14,
  },
  {
    id: 14,
    name: "Employment",
    quantity: 1,
  },
  {
    id: 15,
    name: "Entertainment",
    quantity: 3,
  },
  {
    id: 16,
    name: "Financial Services",
    quantity: 1,
  },
  {
    id: 18,
    name: "Food & Catering Services",
    quantity: 14,
  },
  {
    id: 19,
    name: "Functions & Exhibitions",
    quantity: 10,
  },
  {
    id: 20,
    name: "Furniture",
    quantity: 5,
  },
  {
    id: 21,
    name: "Government & Law",
    quantity: 1,
  },
  {
    id: 22,
    name: "Health & Beauty",
    quantity: 31,
  },
  {
    id: 23,
    name: "Home & Garden",
    quantity: 71,
  },
  {
    id: 24,
    name: "Laundry Services",
    quantity: 1,
  },
  {
    id: 25,
    name: "Legal",
    quantity: 4,
  },
  {
    id: 26,
    name: "Motoring",
    quantity: 32,
  },
  {
    id: 27,
    name: "Party Venues & Accessories",
    quantity: 7,
  },
  {
    id: 28,
    name: "Photography",
    quantity: 11,
  },
  {
    id: 29,
    name: "Promotional Gifts",
    quantity: 3,
  },
  {
    id: 30,
    name: "Property",
    quantity: 23,
  },
  {
    id: 31,
    name: "Recreation",
    quantity: 2,
  },
  {
    id: 32,
    name: "Shopping",
    quantity: 14,
  },
  {
    id: 33,
    name: "Shopping Centres",
    quantity: 1,
  },
  {
    id: 34,
    name: "Solar Solutions",
    quantity: 1,
  },
  {
    id: 35,
    name: "Sports",
    quantity: 7,
  },
  {
    id: 36,
    name: "Travel Services",
    quantity: 5,
  },
  {
    id: 37,
    name: "Wedding",
    quantity: 16,
  },
];
